import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';

export const TestimonialsSection = () => {
  return (
      <section id="testimonials" className="py-20 md:py-32 bg-bg-section relative overflow-hidden">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#8FEC78]/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#81DD67]/10 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />

        <div className="container relative z-10">
          {/* Section Header */}
          <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-wash text-accent-text text-sm font-medium mb-4">
            Recensioni
          </span>
            <h2 className="heading-2 mb-4">
              Amato da migliaia di<br />
              <span className="text-accent-text">automobilisti elettrici</span>
            </h2>
            <p className="body-large text-text-secondary">
              Scopri cosa dicono i nostri utenti su EZVI'.
            </p>
          </div>

          {/* Testimonials Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto">
            {testimonials.map((testimonial) => (
                <div
                    key={testimonial.id}
                    className="product-card group hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 relative"
                >
                  {/* Quote icon decoration */}
                  <div className="absolute top-6 right-6 opacity-10 group-hover:opacity-20 transition-opacity">
                    <Quote size={48} className="text-accent-text" />
                  </div>

                  {/* Rating */}
                  <div className="flex items-center gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                        <Star
                            key={i}
                            size={18}
                            className="fill-[#8FEC78] text-[#8FEC78] drop-shadow-sm"
                        />
                    ))}
                  </div>

                  {/* Quote */}
                  <p className="body-medium text-text-body mb-6 leading-relaxed relative z-10">
                    "{testimonial.text}"
                  </p>

                  {/* Author */}
                  <div className="flex items-center gap-3 pt-4 border-t border-gray-200">
                    {/* Avatar Image */}
                    {testimonial.avatar ? (
                        <div className="relative">
                          <img
                              src={`/images/${testimonial.avatar}`}
                              alt={testimonial.name}
                              className="w-12 h-12 rounded-full object-cover ring-2 ring-white shadow-md"
                              onError={(e) => {
                                // Fallback to initials if image fails to load
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'flex';
                              }}
                          />
                          <div
                              className="hidden w-12 h-12 rounded-full bg-gradient-to-br from-accent-primary to-accent-strong items-center justify-center ring-2 ring-white shadow-md"
                          >
                      <span className="text-sm font-semibold text-white">
                        {testimonial.name.split(' ').map(n => n[0]).join('')}
                      </span>
                          </div>
                        </div>
                    ) : (
                        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-accent-primary to-accent-strong flex items-center justify-center ring-2 ring-white shadow-md">
                    <span className="text-sm font-semibold text-white">
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </span>
                        </div>
                    )}

                    <div className="flex-1">
                      <div className="font-semibold text-text-primary text-base">
                        {testimonial.name}
                      </div>
                      <div className="text-sm text-text-secondary">
                        {testimonial.role}
                      </div>
                    </div>
                  </div>
                </div>
            ))}
          </div>

          {/* Bottom CTA or Stats (optional) */}
          <div className="text-center mt-16">
            <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/60 backdrop-blur-sm border border-[rgba(0,0,0,0.05)] shadow-sm">
              <div className="flex -space-x-2">
                {[1, 2, 3, 4].map((i) => (
                    <div
                        key={i}
                        className="w-8 h-8 rounded-full bg-gradient-to-br from-accent-primary to-accent-strong border-2 border-white"
                    />
                ))}
              </div>
              <span className="text-sm font-medium text-text-secondary ml-2">
              Unisciti a <span className="font-bold text-accent-text">5.000+</span> utenti soddisfatti
            </span>
            </div>
          </div>
        </div>
      </section>
  );
};

export default TestimonialsSection;
